<div id="notes" class="page-layout carded left-sidenav" style="background-color: #777770 !important;">

    <!-- TOP BACKGROUND -->
    <div fxFill style="background-color:#fafafa; z-index:1; position:absolute;"></div>
    <div class="top-bg mat-accent-bg"></div>
    <!-- / TOP BACKGROUND -->

    <mat-sidenav-container>

        <!-- SIDENAV -->
        <mat-sidenav class="sidenav" align="start" mode="side" opened="true" fuseMatSidenavHelper="carded-left-sidenav"
            mat-is-locked-open="gt-md">
            <notes-main-sidenav [readOnly]="userReadOnly || archived"></notes-main-sidenav>
        </mat-sidenav>
        <!-- / SIDENAV -->

        <!-- CENTER -->
        <div class="center">

            <!-- CONTENT HEADER -->
            <div class="header" fxLayout="row" fxLayoutAlign="start center">

                <div class="search-wrapper" fxFlex fxLayout="row" fxLayoutAlign="start center">

                    <button mat-icon-button class="mat-icon-button sidenav-toggle"
                        fuseMatSidenavToggler="carded-left-sidenav" fxHide.gt-md aria-label="Toggle Sidenav">
                        <mat-icon>menu</mat-icon>
                    </button>

                    <div class="search mat-white-bg" flex fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon>search</mat-icon>
                        <input [formControl]="searchInput" placeholder='Search for a note' fxFlex
                            aria-label="Search for a note">
                    </div>
                </div>

            </div>
            <!-- / CONTENT HEADER -->

            <!-- CONTENT CARD -->
            <div class="content-card mat-white-bg" [ngClass]="{'current-note-selected':currentNote}">

                <!-- CONTENT TOOLBAR -->
                <div class="toolbar px-24 py-8">
                    <div class="note-selection" fxFlex="row" fxLayoutAlign="start center">
                        <mat-checkbox (click)="toggleSelectAll()" id="toggleSelectAll" aria-label="Toggle Select All" matTooltip="Toggle Select All"
                            [checked]="hasSelectedNotes" [indeterminate]="isIndeterminate"></mat-checkbox>

                        <button mat-icon-button [matMenuTriggerFor]="selectMenu" aria-label="Select Notes">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu #selectMenu="matMenu">
                            <button mat-menu-item (click)="selectNotes()">All</button>
                            <button mat-menu-item (click)="deselectNotes()">None</button>
                            <button mat-menu-item (click)="selectNotes('starred', true)">Starred</button>
                            <button mat-menu-item (click)="selectNotes('starred', false)">Not Starred</button>
                            <button mat-menu-item (click)="selectNotes('important', true)">Important</button>
                            <button mat-menu-item (click)="selectNotes('important', false)">Not Important</button>
                            <button mat-menu-item (click)="selectNotes('sensitive', true)">Sensitive</button>
                            <button mat-menu-item (click)="selectNotes('sensitive', false)">Not Sensitive</button>
                        </mat-menu>

                        <div class="toolbar-separator" *ngIf="hasSelectedNotes && (!userReadOnly)"></div>

                        <button mat-icon-button (click)="toggleStarredOnSelectedNotes()"
                            *ngIf="hasSelectedNotes && (!userReadOnly)" aria-label="Toggle Starred"
                            matTooltip="Toggle Starred">
                            <mat-icon class="star">star</mat-icon>
                        </button>

                        <button mat-icon-button (click)="toggleImportantOnSelectedNotes()"
                            *ngIf="hasSelectedNotes && (!userReadOnly)" aria-label="Toggle Important"
                            matTooltip="Toggle Important">
                            <mat-icon class="important">error</mat-icon>
                        </button>

                        <button mat-icon-button (click)="toggleSensitiveOnSelectedNotes()"
                            *ngIf="hasSelectedNotes && (!userReadOnly)" aria-label="Toggle Sensitive"
                            matTooltip="Toggle Sensitive">
                            <mat-icon class="sensitive">lock</mat-icon>
                        </button>

                        <div class="toolbar-separator" *ngIf="hasSelectedOnlyDraftNotes && (!userReadOnly)"></div>

                        <button mat-icon-button (click)="deleteSelectedNotes()"
                            *ngIf="hasSelectedOnlyDraftNotes && (!userReadOnly)" aria-label="Delete" matTooltip="Delete">
                            <mat-icon>delete</mat-icon>
                        </button>

                        <div class="toolbar-separator" *ngIf="hasSelectedNotes"></div>

                        <button mat-icon-button (click)="printSelectedNotes()" *ngIf="hasSelectedNotes" aria-label="Print"
                            matTooltip="Print">
                            <mat-icon>print</mat-icon>
                        </button>

                        <div class="toolbar-separator"></div>

                        <span *ngIf="!noteOrderAscending">Newest to Oldest</span>
                        <span *ngIf="noteOrderAscending">Oldest to Newest</span>
                        <button [matMenuTriggerFor]="noteOrderMenu" aria-label="Note Order">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu #noteOrderMenu="matMenu">
                            <button mat-menu-item (click)="setNoteOrder(false)" aria-label="Newest to Oldest">Newest to
                                Oldest</button>
                            <button mat-menu-item (click)="setNoteOrder(true)" aria-label="Oldest to Newest">Oldest to
                                Newest</button>
                        </mat-menu>

                        <mat-divider *ngIf="showNoteTypeFilter" class='style-fix' [vertical]="true"></mat-divider>

                        <button *ngIf="showNoteTypeFilter" mat-icon-button class="mat-icon-button"
                            [matMenuTriggerFor]="mnuNoteTypeFilter" #noteTypeFilter aria-label="Note Type Filter"
                            matTooltip="Note Type Filter">
                            <mat-icon>filter_list</mat-icon>
                        </button>
                        <mat-menu #mnuNoteTypeFilter="matMenu">
                            <button mat-menu-item *ngFor="let filter of this.noteTypes"
                                (click)="applyNoteTypeFilter(filter)">
                                <mat-icon [ngStyle]="!filter.selected?{'color': 'transparent'}: {}">done</mat-icon>
                                {{filter.name}}
                            </button>
                        </mat-menu>
                    </div>

                    <div>
                        <button mat-icon-button [disabled]="!hasPrevious" (click)="readPrevious()"
                            aria-label="Go to Previous Note" matTooltip="Go to Previous Note">
                            <mat-icon>keyboard_arrow_left</mat-icon>
                        </button>
                    </div>
                    <div>
                        <button mat-icon-button [disabled]="!hasNext" (click)="readNext()" aria-label="Go to Next Note" matTooltip="Go to Next Note">
                            <mat-icon>keyboard_arrow_right</mat-icon>
                        </button>
                    </div>
                </div>
                <!-- / CONTENT TOOLBAR -->

                <!-- CONTENT -->
                <div class="content h-100-p" fxFlexAlign="row" fxLayoutAlign="stretch stretch">

                    <note-list fxFlex [parent]="parent" [readOnly]="userReadOnly"></note-list>
                    <note-details fxFlex [parent]="parent" [readOnly]="userReadOnly"></note-details>

                </div>
                <!-- / CONTENT -->

            </div>
            <!-- / CONTENT CARD -->

        </div>
        <!-- / CENTER -->

    </mat-sidenav-container>

</div>